<!-- <div style=" margin-top: 6.5%;display: flex;width: 100%;">
    <app-jsip-left-pannel (sidenavToggle)="isSidenavOpen = $event" class="jsip_Lpannel" [class.collapsed]="!isSidenavOpen"></app-jsip-left-pannel>
<div class="topDiv_with_LPannel" [class.collapsed]="!isSidenavOpen">
  <app-jsip-product-info-bar (productNavToggle)="selectedProductDetails = $event"></app-jsip-product-info-bar> -->
<div class="main-container" style="margin-top: 0%;" [class.workflow-mode]="showForm"
     [class.default-mode]="!showForm" [class.PrdCollapsed]="selectedProductDetails == null" >

  <div *ngIf="!showForm" class="label-bar">

  <label
    style="font-size: 18px; font-weight: 500;border-bottom: unset;"
    i18n="@@spmsUserReg"
    class="textColour">
    Product Safety Strategy Templates
  </label>
   <span class="example-spacer"></span>

  <!-- <app-jsignal-nav-links></app-jsignal-nav-links> -->
   <app-common-button
          title="Create Template"
          label="Create Template"
          icon="fas fa-plus-circle"
          width="130px"
          [buttonId]="114"
          [critical]="true"
          (clicked)="onCreateTemplate($event)"
           style="margin-left: 6px;margin-right:6px;"
        >
        </app-common-button>

        <app-common-button
          title="Download"
          label="Download"
          icon="fas fa-download"
          [critical]="false"
          [buttonId]="1111"
          (clicked)="onDownloadHistory($event)"
           style="margin-left: 6px;margin-right:6px;"
         
        >
        </app-common-button>

        <!-- Refresh Button -->
        <app-common-button
          label="Refresh"
          title="Refresh"
          icon="fas fa-sync-alt"
         
          [buttonId]="1111"
          [critical]="false"
          (clicked)="onRefresh($event)"
          style="margin-left: 6px;margin-right:6px;"
        >
        </app-common-button>

</div>


<mat-horizontal-stepper *ngIf="showForm" [linear]="true" class="custom-stepper" #stepper>
  <mat-step  label="Template">
    <form [formGroup]="stepOneFormGroup" >
        <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 10px;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;">Create Template</label>
        </div>
      <div class="row" style="margin-bottom: 1rem;">
        <div class="col-lg-4">
          <mat-form-field appearance="outline">
          <mat-label>Template Name <span class="text-danger"></span></mat-label>
          <input matInput formControlName="templateName" />
          <mat-error
            *ngIf="stepOneFormGroup.get('templateName')?.touched 
                && stepOneFormGroup.get('templateName')?.hasError('required')"
          >
            Template Name is required
          </mat-error>
        </mat-form-field>
        </div>
      </div>
       <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 10px;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;">Document Section</label>
        </div>
        <div class="row">
        <div class="col-lg-4">
           <mat-form-field appearance="outline" class="w-100">
              <mat-label>Select Activity </mat-label>
              <mat-select
                formControlName="activities"
                multiple
                (closed)="clearActivitySearch()" 
              >
                <!-- Wrapped search input inside mat-form-field -->
                <mat-option [disabled]="true" class="search-input-option">
                  <mat-form-field class="w-100 m-0">
                    <input
                      matInput
                      placeholder="Search activities..."
                      [(ngModel)]="activitySearchText"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="filterActivities()"
                      (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      name="searchActivity"
                      autocomplete="off"
                    />
                  </mat-form-field>
                </mat-option>
                    <mat-option (click)="onCreateActivityClick()" class="CreateOption" value="Others">  <em  class="fas fa-plus-circle" style="font-size: 16px;
                  padding: 0 5px;padding-left: 0;"></em>Create New Activity</mat-option>
                    <mat-divider></mat-divider>

                <!-- Filtered list -->
                <ng-container
                  *ngIf="filteredActivities.length > 0; else noActivities"
                >
                  <mat-option
                    *ngFor="let activity of filteredActivities"
                    [value]="activity.activityName"
                  >
                    {{ activity.activityName }}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
               <ng-template #noActivities>
              <mat-option disabled>No activities found</mat-option>
            </ng-template>
        </div>
      </div>
       <div class="row">
        <div
          formArrayName="sections"
          class="col-lg-12"
          style="margin-top: 1%;"
          cdkDropList
          [cdkDropListData]="stepOneSections.controls"
          (cdkDropListDropped)="onSectionReorder($event)"
        >
         
          <div
            *ngFor="let sec of stepOneSections.controls; let i = index"
            [formGroupName]="i"
            class="p-3 border rounded"
            cdkDrag
            style="position: relative;margin-bottom: 2%;"
          >
          <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" (click)="removeStepOneSection(i)" style="    
          width: 25px !important;
          box-shadow: none !important;
          background-color: #E50707;
          height: 25px;
          top: -15px;
          position: absolute;
          right: -15px;
          padding: 0;
          border-radius: 50%;
          margin: 0;
          font-weight: 500;
          font-size: 18px;">✖</button>
            <!-- drag handle optional -->
            <div cdkDragHandle class="drag-handle mb-2" style="cursor: grab">
              <mat-icon>drag_handle</mat-icon>
            </div>

              <!-- title + remove -->
            <ng-container [ngSwitch]="sec.get('type').value">
              <div class="row">
                <div class="col-lg-4">
                  <mat-form-field appearance="outline" class="flex-grow-1">
                  <mat-label>Title</mat-label>
                  <input matInput formControlName="title" required />
                  <!-- <mat-hint>Required field</mat-hint> -->
                  <mat-error *ngIf="sec.get('title')?.hasError('required')">
                    Title is mandatory
                  </mat-error>
                </mat-form-field>
                </div>
              </div>
              

              <!-- conditional Signal Detection block… -->
              <ng-container *ngSwitchCase="'Text'">
                <ng-container
                  *ngIf="
                    sec.get('title')?.value ===
                    'Signal Detection and Management'
                  "
                >
                <div class="row">
                <div class="col-lg-4">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>Signal Sources</mat-label>
                    <mat-select formControlName="signalSources" multiple>
                      <mat-option
                        *ngFor="let src of SignalSources"
                        [value]="src.lookupvalue"
                      >
                        {{ src.lookupvalue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  </div>
                   <div class="col-lg-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tools & Methods</mat-label>
                    <textarea
                      matInput
                      formControlName="toolsMethods"
                      rows="2"
                    ></textarea>
                  </mat-form-field>
                   </div>
                  </div>
                </ng-container>
              </ng-container>

              <!-- TEXT SECTION -->
              <ng-container *ngSwitchCase="'Text'">
                  <div class="row">
                <div class="col-lg-8">
                  
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea
                    matInput
                    formControlName="description"
                    rows="3"
                    required
                  ></textarea>
                  <!-- <mat-hint>Required field</mat-hint> -->
                  <mat-error
                    *ngIf="sec.get('description')?.hasError('required')"
                  >
                    Description is mandatory
                  </mat-error>
                </mat-form-field>
                  </div>
                  </div>
              </ng-container>

              <!-- TABLE SECTION (new) -->
              <ng-container *ngSwitchCase="'Table'">
                <!-- column headers -->
                 <div class="table-scroll-container">
                <div formArrayName="columns" class="d-flex mb-2">
                  <div
                    *ngFor="
                      let colCtrl of sec.get('columns').controls;
                      let ci = index
                    "
                    style="margin-right:1%"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label>Header {{ ci + 1 }}</mat-label>
                      <input matInput [formControlName]="ci" required />
                      <!-- <mat-hint>Required field</mat-hint> -->
                      <mat-error *ngIf="colCtrl.hasError('required')"
                        >Header is mandatory</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <!-- table body -->
                <div formArrayName="rows">
                  <div
                    *ngFor="let row of sec.get('rows').controls; let ri = index"
                    [formGroupName]="ri"
                    class="d-flex mb-2"
                  >
                    <div
                      *ngFor="let cell of row.controls; let ci = index"
                      style="margin-right:1%"
                    >
                      <mat-form-field appearance="outline">
                        <mat-label>Cell {{ ri + 1 }}–{{ ci + 1 }}</mat-label>
                        <input matInput [formControlName]="ci" required />
                        <!-- <mat-hint>Required field</mat-hint> -->
                        <mat-error *ngIf="cell.hasError('required')"
                          >Cell value is mandatory</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                </div>
              </ng-container>
            </ng-container>
            </div>
            </div>
       </div>
     
    </form>
     <!-- ADD BUTTON now simply calls addStepOneSection() -->
          <!-- Add Section button -->
          <!-- <button
            mat-stroked-button
            class="animated-button"
            [style.background-color]="backgroundColorButton"
            [matMenuTriggerFor]="addSectionMenu"
          >
            <mat-icon>add</mat-icon> Add Section
          </button> -->
          <!-- <button  i18n="@@TargetClear" type="button"
                    class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    [matMenuTriggerFor]="addSectionMenu"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: fit-content;
    box-shadow: none !important;" [style.background-color]="backgroundColorButton">Add Section<em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Visuals"></em></button> -->
    <app-common-button
 
          label="Add Section"
 
          title="Add Section "
 
          icon="fas fa-plus-circle"
 
          [buttonId]="1111"
          [matMenuTriggerFor]="addSectionMenu"
 
          width="110px"
          [critical]="false"
          
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
          </app-common-button>

          <mat-menu #addSectionMenu="matMenu">
            <button mat-menu-item (click)="addStepOneSection()">
              <mat-icon>notes</mat-icon>
              <span>Text Section</span>
            </button>
            <button
              mat-menu-item
              [matMenuTriggerFor]="tableSizeMenu"
              #tableSizeTrigger="matMenuTrigger"
            >
              <mat-icon>table_chart</mat-icon>
              <span>Table Section</span>
            </button>
          </mat-menu>

          <mat-menu #tableSizeMenu="matMenu" class="p-2">
            <div class="table-size-picker">
              <div class="grid">
                <div
                  *ngFor="let _r of tableGrid; let i = index"
                  class="grid-row"
                >
                  <div
                    *ngFor="let _c of tableGrid; let j = index"
                    class="grid-cell"
                    [class.selected]="i < tableRows && j < tableCols"
                    (mouseenter)="onGridHover(i + 1, j + 1)"
                    (click)="
                      addTableSection(tableRows, tableCols);
                      tableSizeTrigger.closeMenu()
                    "
                  ></div>
                </div>
              </div>
              <div class="picker-label">{{ tableRows }} × {{ tableCols }}</div>
            </div>
          </mat-menu>
          <div  class="row topRowMargins" style="margin-bottom: 2%;">

        <div class="col-lg text-center" >
          <div style="text-align: start">

          </div>
            <div style="text-align: end">
               <!-- <button i18n="@@TargetCancel" type="button" (click)="cancelWorkflow()"  
                     class="slim-button cancelButton download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.border-color]="backgroundColorButton" >Back</button>    -->
     <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="cancelWorkflow()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

                    <!-- <button  i18n="@@TargetClear" type="button" (click)="goToStepTwo(stepper)"
                    class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.background-color]="backgroundColorButton">Next</button> -->

    		     <app-common-button
 
          label="Next"
 
          title="Next "
 
          
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="goToStepTwo(stepper)"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>


            </div>
 
        </div>
        
    </div>
  </mat-step>
  <mat-step label="Preview">
    <div style="width: 90%;
    margin: auto;
    border: 2px solid #DFDEDE;
    padding: 1%;
    margin-top: 2%;
    margin-bottom: 5%;
    border-radius: 5px;">
     <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-top: 10px;font-size: 25px;font-weight: 700;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;">{{ stepOneFormGroup.get("templateName")!.value }}</label>
        </div>
        <div *ngIf="previewActivities.length">
         <div  class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0; 
          margin-bottom: 0;
          margin-top: 10px;border: none;
          ">
          <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;">Activities</label>
        </div>
         <ul style="padding-left: 20px;"> 
          <li *ngFor="let a of previewActivities">{{ a.activity }}</li>
        </ul>
        </div>
        <div *ngIf="previewData.length; else noSections">
          <div *ngFor="let sec of previewData">
             <div  class="row topRowMargins headerStyle" style="
              margin-right: 0;
              margin-left: 0; 
              margin-top: 2%;
              ">
              <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;">{{ sec.title }}</label>
            </div>
             <ng-container *ngIf="sec.type === 'Text'">
            <p *ngIf="sec.description">{{ sec.description }}</p>
            <div *ngIf="sec.signalSources">
               <div  class="row topRowMargins headerStyle" style="
                  margin-right: 0;
                  margin-left: 0; 
                  margin-bottom: 0;
                  margin-top: 10px;border: none;
                  ">
                  <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 4px;">Signal Sources</label>
                </div>
              <ul style="padding-left: 20px;">
                <li *ngFor="let s of sec.signalSources">{{ s }}</li>
              </ul>
            </div>

            <div *ngIf="sec.toolsMethods">
              <strong>Tools & Methods:</strong>
              <p>{{ sec.toolsMethods }}</p>
            </div>
          </ng-container>
          <ng-container *ngIf="sec.type === 'Table'">
            <!-- New plain HTML table -->
            <table class="custom-table">
              <thead>
                <tr style=" background-color: #9d9c9c;
  color: white;">
                  <th style="padding:5px;padding-left: 15px;" *ngFor="let col of sec.columns">{{ col }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of sec.rows; let i = index"  [ngClass]="{ 'even-row': i % 2 === 0, 'odd-row': i % 2 !== 0 }">
                  <td style="padding:5px;padding-left: 15px;" *ngFor="let cell of row">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>
          </div>
        </div>
          <ng-template #noSections>
          <p class="text-muted">No sections added.</p>
        </ng-template>
        <div  class="row topRowMargins" style="margin-bottom: 2%;">

        <div class="col-lg text-center" >
          <div style="text-align: start">

          </div>
            <div style="text-align: end">
               <!-- <button *ngIf="!previewMode" i18n="@@TargetCancel" type="button" (click)="stepper.previous()"  
                     class="slim-button cancelButton download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.border-color]="backgroundColorButton" >Back</button>    -->
              		     <app-common-button
              *ngIf="!previewMode"
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="stepper.previous()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

    <ng-container *ngIf="!previewMode; else previewOnly">
                    <!-- <button  i18n="@@TargetClear" type="button" (click)="OnSubmit()"
                    class="slim-button download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.background-color]="backgroundColorButton">Submit</button> -->
    		     <app-common-button
 
          label="Submit"
 
          title="Submit "
 
         
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="OnSubmit()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
</ng-container>
 <ng-template #previewOnly>
   <!-- <button  i18n="@@TargetCancel" type="button" (click)="cancelWorkflow()"  
                     class="slim-button cancelButton download-btn popup gridColour btn btn-rounded-button  waves-effect waves-light text-capitalize"
                    [style.background-color]="backgroundColorButton"
                    style="padding: 5px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    width: 10%;
    box-shadow: none !important;" [style.border-color]="backgroundColorButton" >Back</button>    -->
     <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="cancelWorkflow()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
 </ng-template>
            </div>
        </div>
    </div>
    </div>
  </mat-step>
</mat-horizontal-stepper>

<div class="agGridOuterDiv" style="margin-top: 1.5%;" *ngIf="!showForm">
  <ag-grid-angular
        style="height: 58vh"
        id="Grid"
        class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefs"
        [rowMultiSelectWithClick]="true"
        [animateRows]="true"
        [pagination]="true"
        [rowData]="gridRowData"
        [defaultColDef]="defaultColDef"
        [suppressPaginationPanel]="true"
        [rowHeight]="35"
        [headerHeight]="35"
        [enableBrowserTooltips]="true"
        [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize"
        [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true"
        [components]="components"
        [debug]="true"
        (paginationChanged)="onPaginationChanged()"
        (gridReady)="onGridReady($event)"
        [rowClassRules]="rowClassRules"
        [getRowStyle]="getRowStyle"
      >
      </ag-grid-angular>
       <mat-toolbar
        class="agGridtoperDiv card"
        style="
          background: rgb(244 243 245);
             border: 1px solid #a9a9a9a8;
              margin-top: 0;
              box-shadow: none;
              border-radius: unset;
              border-top: none;
        "
      >
        <span class="example-spacer"></span>

        <!-- Create Template -->
        <!-- <button class="download-btn popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.background-color]="backgroundColorButton" (click)="onCreateTemplate()">
          <em class="fas fa-file-alt"></em> Create Template
        </button> -->
        <!-- Create Template Button -->
        

        <div class="insertPageNoDiv">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@Targetpageno">Page No</mat-label>
            <input
              matInput
              type="text"
              (input)="onRunSearchChange($event.target.value)"
            />
          </mat-form-field>
        </div>
        <div class="selectRecordsDiv" style="width: 9.5%">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label i18n="@@Targetrecords" style="color: black"
              >Records</mat-label
            >
            <mat-select
              ngDefaultControl
              [(ngModel)]="RunpageSize"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onRunPageSizeChanged(value)"
            >
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="card pagination paginationFirstButton paginationFirstlastButton"
          style="box-shadow: none;"
        >
          <em
            class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onRunBtFirst()"
          ></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded"  style="box-shadow: none;">
          <ul>
            <li class="paginationliicon">
              <em
                class="fas fa-angle-left waves-effect waves-light"
                (click)="onRunBtPrevious()"
              ></em>
            </li>
            <li>{{ RuncurrentPage }}/{{ RuntotalPages }}</li>
            <li class="paginationliicon" style="padding: 0">
              <em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onRunBtNext()"
              ></em>
            </li>
          </ul>
        </div>
        <div
          class="card pagination paginationLastButton paginationFirstlastButton" 
           style="box-shadow: none;"
        >
          <em
            class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onRunBtLast()"
          ></em>
        </div>
      </mat-toolbar>
</div>
</div>
<!-- </div>
</div> -->
